// src/resources/Letters/letterUtils.js
import { db } from "../../firebase/firebase";
import {
  doc,
  getDoc,
  setDoc,
  addDoc,
  collection,
  serverTimestamp,
} from "firebase/firestore";

// Standard map (copied from your original)
export const typeCodeMap = {
  "Warning Letter": "WL",
  "Offer Letter": "OF",
  "Transport Contract": "TC",
  "Salary Certificate": "SC",
  "Employment Letter": "EL",
  "Experience Letter": "EX",
  "Termination Letter": "TL",
  "Promotion Letter": "PL",
  "Transfer Letter": "TR",
};

// Generate Reference Number
export const generateReference = async (company, type, setGenerating, notify) => {
  if (!company || !type) return "";
  setGenerating(true);

  try {
    const year = new Date().getFullYear();
    const short =
      company.shortCode ||
      company.name
        .split(" ")
        .map((w) => w[0].toUpperCase())
        .join("")
        .substring(0, 3);

    const typeCode = typeCodeMap[type] || "OT";
    const counterRef = doc(db, "settings", "letterCounters");
    const snap = await getDoc(counterRef);
    const data = snap.exists() ? snap.data() : {};
    const companyCounter = data[company.id] || {};
    const typeYearKey = `${typeCode}_${year}`;
    const current = companyCounter[typeYearKey] || 0;
    const newCounter = current + 1;

    await setDoc(
      counterRef,
      { [company.id]: { ...companyCounter, [typeYearKey]: newCounter } },
      { merge: true }
    );

    const padded = String(newCounter).padStart(4, "0");
    const refNo = `${short}/${typeCode}/${year}/${padded}`;
    return refNo;
  } catch (err) {
    console.error("❌ Reference generation failed:", err);
    notify("⚠️ Could not generate reference number.", { type: "warning" });
    return "";
  } finally {
    setGenerating(false);
  }
};

// Save new letter to Firestore
export const saveLetter = async (company, refNo, { type, subject, body, direction, date }) => {
  // Save new type to "letterTypes" if not existing
  if (!typeCodeMap[type]) {
    const typeRef = doc(db, "settings", "letterTypes");
    await setDoc(typeRef, { [type]: true }, { merge: true });
  }

  await addDoc(collection(db, "letters"), {
    companyId: company.id,
    companyName: company.name,
    referenceNo: refNo,
    type,
    subject,
    body,
    direction,
    date,
    createdBy: localStorage.getItem("email") || "",
    status: "pending",
    createdAt: serverTimestamp(),
  });
};
